import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgAntiAgingGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M39.25 23.25h-3.48v-9.44c0-1.01.25-4.31 3.48-4.31.41 0 .75-.34.75-.75S39.66 8 39.25 8c-3.02 0-4.98 2.28-4.98 5.81v9.44h-9.52v-8.14c0-4.12-2.58-7.11-6.15-7.11-4.42 0-6.44 3.43-6.44 6.62v8.63H8.75c-.41 0-.75.34-.75.75s.34.75.75.75h3.41v9.98c0 2.54-1.1 3.78-3.38 3.78-.41 0-.75.34-.75.75s.34.75.75.75c3.1 0 4.88-1.92 4.88-5.28v-9.98h9.59v8.5c0 3.98 2.55 6.75 6.21 6.75 4.36 0 6.32-3.41 6.32-6.78v-8.47h3.48c.41 0 .75-.34.75-.75s-.35-.75-.76-.75Zm-25.59 0v-8.63c0-2.36 1.29-5.12 4.94-5.12 2.74 0 4.65 2.3 4.65 5.61v8.14h-9.59Zm20.61 9.97c0 2.44-1.26 5.28-4.82 5.28-2.86 0-4.71-2.06-4.71-5.25v-8.5h9.52v8.47h.01Z",
    fill: "currentColor"
  }));
}

export { SvgAntiAgingGlyphSecondary as default };
